import React from "react";
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';

var LanguageSelector = function LanguageSelector(_ref) {
  var languagesList = _ref.languagesList,
      isDisplayLanguageContentLabel = _ref.isDisplayLanguageContentLabel,
      languageHintText = _ref.languageHintText,
      language = _ref.language,
      setFieldValue = _ref.setFieldValue;
  return /*#__PURE__*/React.createElement(StyledFormField, null, /*#__PURE__*/React.createElement("span", null, isDisplayLanguageContentLabel && /*#__PURE__*/React.createElement("p", null, languageHintText), languagesList.length > 0 && languagesList.map(function (lang, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: lang.localeCode
    }, /*#__PURE__*/React.createElement(Label, {
      active: lang.localeCode === language,
      onClick: function onClick() {
        return setFieldValue('language', lang.localeCode);
      },
      name: "language"
    }, lang.shortFriendlyName.toUpperCase(), " ", lang.localeCode === 'en' ? '* ' : ''), i < languagesList.length - 1 && '|', ' ');
  })));
};

LanguageSelector.propTypes = {
  className: PropTypes.string,
  languagesList: PropTypes.array,
  isDisplayLanguageContentLabel: PropTypes.bool,
  languageHintText: PropTypes.string,
  language: PropTypes.string,
  setFieldValue: PropTypes.func
};
var Label = styled.span.withConfig({
  displayName: "LanguageSelector__Label",
  componentId: "sc-srakak-0"
})(["cursor:pointer;background-color:transparent !important;padding:0;font-size:16px;color:", ";font-weight:", ";"], function (_ref2) {
  var active = _ref2.active;
  return active ? '#1d2327' : 'gray';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? 'bold' : 'normal';
});
var StyledFormField = styled(Form.Group).withConfig({
  displayName: "LanguageSelector__StyledFormField",
  componentId: "sc-srakak-1"
})(["position:relative;top:-6px;display:inline-block;p{margin-right:20px;display:inline-block;font-size:16px;font-weight:bold;}"]);
export default LanguageSelector;